import { render, staticRenderFns } from "./FormBank.vue?vue&type=template&id=3d5c56ea&scoped=true"
import script from "./FormBank.vue?vue&type=script&lang=js"
export * from "./FormBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5c56ea",
  null
  
)

export default component.exports